import React from 'react';

const PrivacyPolicyContent = () => (
  <div>
    <p><strong>1. Кто мы</strong></p>
    <p>Оператор: Общество с ограниченной ответственностью «ИИП-ИНТЕЛЛЕКТУАЛЬНЫЕ СИСТЕМЫ» (ООО «ИИП ИС»), сервис поиска товарных знаков.</p>

    <p><strong>2. Какие данные</strong></p>
    <p>
      Контактные данные (имя, телефон, email), сведения о заявке/компании, технические данные
      (IP, cookies, браузер/устройство).
    </p>

    <p><strong>3. Зачем</strong></p>
    <p>
      Оказание услуг и обратная связь, информирование о статусе, исполнение договора и требований
      закона, улучшение сервиса и обеспечение безопасности.
    </p>

    <p><strong>4. Основания</strong></p>
    <p>Согласие, исполнение договора, исполнение обязанностей по закону, законные интересы оператора.</p>

    <p><strong>5. Передача</strong></p>
    <p>
      Подрядчики для хостинга, связи, аналитики при соблюдении конфиденциальности; госорганы —
      на основании закона.
    </p>

    <p><strong>6. Сроки и защита</strong></p>
    <p>
      Храним столько, сколько нужно для целей/закона. Используем ограниченный доступ, шифрование
      каналов, резервное копирование.
    </p>

    <p><strong>7. Права пользователя</strong></p>
    <p>
      Запросить доступ, исправление, ограничение, удаление, отзыв согласия, возражение. Обращения
      принимаем по контактам ниже.
    </p>

    <p><strong>8. Cookies/аналитика</strong></p>
    <p>Можем использовать cookies и аналитику; их можно ограничить в браузере, часть функций может исчезнуть.</p>

    <p><strong>9. Контакты</strong></p>
    <p>
      Email: <a href="mailto:office@prointy.ru">office@prointy.ru</a><br />
      Телефон: <a href="tel:+74993221284">8 (499) 322-12-84</a><br />
      Адрес: 124482, г. Москва, г. Зеленоград, корпус 305
    </p>

    <p><strong>10. Обновления</strong></p>
    <p>Актуальная версия публикуется на сайте. Продолжение использования = согласие с новой редакцией.</p>
  </div>
);

export default PrivacyPolicyContent;
